/* Extend Shopify's payment terms without duplicating its plan/modal logic. */
(() => {
  if (!window.customElements) return;
  const hosts = new WeakSet();
  const fragments = new WeakMap();
  const selector = 'shopify-payment-terms';

  function enhance(root) {
    const content = root.querySelector('#shopify-installments-content');
    const cta = root.querySelector('#shopify-installments-cta');
    if (!content || !cta) return;

    // Preserve Shopify's original text node so its renderer can still update it.
    const previous = fragments.get(content);
    if (previous) {
      if (previous.node.parentNode === content && previous.node.data === previous.prefix && previous.button.parentNode === content) return;
      previous.button.remove();
      previous.suffix.remove();
      fragments.delete(content);
    }
    const node = Array.from(content.childNodes).find(child =>
      child.nodeType === Node.TEXT_NODE && /interest-free/i.test(child.data)
    );
    if (!node) return;
    const match = /interest-free/i.exec(node.data);
    const prefix = node.data.slice(0, match.index);
    const suffix = document.createTextNode(node.data.slice(match.index + match[0].length));
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'aw-interest-free-trigger';
    button.textContent = match[0];
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-label', 'Interest-free installments — view sample plans');
    button.addEventListener('click', () => {
      // Resolve the current native trigger after any variant re-render.
      const trigger = root.querySelector('#shopify-installments-cta');
      if (trigger) {
        trigger.focus({ preventScroll: true });
        trigger.click();
      }
    });
    node.data = prefix;
    node.after(button, suffix);
    fragments.set(content, { node, prefix, button, suffix });
  }

  function observe(host) {
    if (hosts.has(host) || !host.shadowRoot) return;
    hosts.add(host);
    const root = host.shadowRoot;
    const style = document.createElement('style');
    style.textContent = `
      .aw-interest-free-trigger {
        appearance: none; display: inline; margin: 0; padding: 0; border: 0;
        background: transparent; color: inherit; font: inherit; letter-spacing: inherit;
        line-height: inherit; cursor: pointer; text-decoration: underline;
        text-underline-offset: 2px;
      }
      .aw-interest-free-trigger:focus-visible { outline: 2px solid currentColor; outline-offset: 2px; border-radius: 2px; }
      .aw-interest-free-trigger:active { opacity: .7; }
    `;
    root.append(style);
    const observer = new MutationObserver(() => enhance(root));
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    enhance(root);
  }

  customElements.whenDefined(selector).then(() => {
    document.querySelectorAll(selector).forEach(observe);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches(selector)) observe(node);
        node.querySelectorAll(selector).forEach(observe);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
